module.exports = __webpack_public_path__ + "img/partner2.9eb3c016.jpeg";